"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Link = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _isReactFragment = require("../utils/isReactFragment");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ToolbarOverflowLayout = require("../Toolbar/_ToolbarOverflowLayout");
var _Link = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Link.css") : void 0);
var _excluded = ["children", "className", "disabled", "href", "innerTextClasses", "matchButtonHeight", "muted", "onClick", "size", "inToolbarOverflow", "toolbarLayoutProps"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-link';

/**
 * **Link** components are used to navigate to another page, another
 * section within a page or an external website.
 *
 * > Links and buttons are sometimes used interchangeably, but from an accessibility perspective,
 * > there are specific use cases for each. Please see
 * > [Design Usage for Link Button and Link](./?path=/docs/design-buttons--docs)
 * > for the distinction between the two and proper usage.
 */

var Link = exports.Link = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Link, _props)) : _props;
  var children = props.children,
    className = props.className,
    disabled = props.disabled,
    href = props.href,
    innerTextClasses = props.innerTextClasses,
    matchButtonHeight = props.matchButtonHeight,
    muted = props.muted,
    onClick = props.onClick,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    inToolbarOverflow = props.inToolbarOverflow,
    toolbarLayoutProps = props.toolbarLayoutProps,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Link.default);
  var isNonActionableHref = function isNonActionableHref() {
    return !href || (0, _trim.default)(href).call(href) === '#';
  };
  var handleClick = function handleClick(event) {
    if (disabled || isNonActionableHref()) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick === null || onClick === void 0 || onClick(event);
  };
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), size !== 'md'), "".concat(CSS_BLOCK, "--muted"), muted), "".concat(CSS_BLOCK, "--disabled"), disabled), "".concat(CSS_BLOCK, "--button-height"), matchButtonHeight));
  var passChildProps = function passChildProps(child, childProps) {
    var childClassName = childProps.className,
      forceSize = childProps.forceSize;
    if (child.displayName === 'Badge') {
      return {
        className: classnames("".concat(CSS_BLOCK, "__badge"), childClassName)
      };
    }
    if (child.displayName === 'Icon') {
      var iconSizeMap = {
        lg: 'sm-minus',
        md: 'xs-plus'
      };
      return {
        className: classnames("".concat(CSS_BLOCK, "__icon"), childClassName),
        size: forceSize || iconSizeMap[size]
      };
    }
    return null;
  };
  var renderChildren = function renderChildren(childNodes) {
    var _context2;
    var textNodeSegment = [];
    var innerTextClassName = classnames(innerTextClasses, "".concat(CSS_BLOCK, "__text"));
    var startIconOrBadge;
    var centerText;
    var endIconOrBadge;
    var alteredChildren = (0, _map.default)(_context2 = _react.default.Children).call(_context2, childNodes, function (child) {
      var _child$type;
      if (child === null) return null;
      if ((0, _isReactFragment.isReactFragment)(child)) {
        return renderChildren(child.props.children);
      }
      var compName = child === null || child === void 0 || (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName;
      var isIconOrBadge = compName === 'Icon' || compName === 'Badge';
      var isTextNodeSegment = ! /*#__PURE__*/_react.default.isValidElement(child) || compName !== 'Icon' && compName !== 'Badge';
      if (isIconOrBadge) {
        if (!startIconOrBadge && !centerText) {
          startIconOrBadge = child;
        } else {
          endIconOrBadge = child;
        }
      } else if (isTextNodeSegment) {
        centerText = child;
      }
      if (isTextNodeSegment) {
        textNodeSegment.push(child);
      } else {
        if (textNodeSegment.length) {
          var textChild = textNodeSegment;
          textNodeSegment = [];
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            className: innerTextClassName
          }, textChild), child);
        }
        return child;
      }
      return null;
    });
    if (inToolbarOverflow) {
      return /*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.ToolbarOverflowLayout, (0, _extends2.default)({
        startIconOrBadge: startIconOrBadge,
        innerTextClassName: innerTextClassName,
        centerText: centerText,
        endIconOrBadge: endIconOrBadge,
        size: size
      }, toolbarLayoutProps));
    }
    if (textNodeSegment.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, alteredChildren, /*#__PURE__*/_react.default.createElement("span", {
        className: innerTextClassName
      }, textNodeSegment));
    }
    return alteredChildren;
  };
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, otherProps, {
    "aria-disabled": disabled,
    className: classes,
    href: !disabled ? href : null,
    onClick: handleClick,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, renderChildren(children)));
});
Link.displayName = 'Link';
Link.propTypes = {
  /** Renderable content for the **Link**. */
  children: _propTypes.default.node,
  /** Custom classes to be added to the `<a>` tag. */
  className: _propTypes.default.string,
  /** Controls whether the **Link** is enabled or disabled. */
  disabled: _propTypes.default.bool,
  /** The destination URL for the **Link**. */
  href: _propTypes.default.string,
  /** Custom classes to be added to the inner `<span>` of the `<a>`
   * that holds the text content. */
  innerTextClasses: _propTypes.default.string,
  /** Provides additional padding so the **Link** match a button’s
   * height of the same `size` and will line up horizontally. */
  matchButtonHeight: _propTypes.default.bool,
  /** Renders the **Link** in an alternate “muted” style. */
  muted: _propTypes.default.bool,
  /** **Link** size. Options are 'lg', 'md'. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** @ignore set by Toolbar Overflow */
  inToolbarOverflow: _propTypes.default.bool,
  /** @ignore set by Toolbar Overflow. */
  toolbarLayoutProps: _propTypes.default.any,
  /** Callback function for onClick events. */
  onClick: _propTypes.default.func
};
var _default = exports.default = Link;